const spacing = 8;

export default spacing;
